import React from "react"

const TailwindProvider = ({ children }) => {
  return <div className="tailwind-scope">{children}</div>
}

export default TailwindProvider
